function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
const Completed = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 221,
  height: 125,
  fill: "none"
}, props), /*#__PURE__*/React.createElement(G, {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#545F71",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M29.083 88.708h44.933m-44.933 25.387h44.933m-44.933-12.687h44.933M3.679 124.349h185.359m-6.762-51.452v51.452m-46.535-52.103v52.103m-42.418-57.92h51.85M20.589 124.35V77.972h61.92v46.377m13.094-56.006v56.006M9.046 68.343v56.006m50.509-81.446h71.796l23.789 17.294m33.924 17.216-29.795-19.806-32.543 20.378m-23.685-4.36-50.69-35.953L.877 74.446m123.764 50.125V90.647h-17.718v33.924m62.168-23.332h-20.167V80.965h20.167v20.274Z"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  stroke: "#111C2B",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M167.829 103.919c28.37 0 51.368-22.971 51.368-51.309 0-28.337-22.998-51.309-51.368-51.309s-51.369 22.972-51.369 51.31c0 28.337 22.999 51.308 51.369 51.308Z"
}), /*#__PURE__*/React.createElement(G, {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M163.618 37.151a3.872 3.872 0 0 0-5.455 0 3.837 3.837 0 0 0 0 5.434M155.074 39.507a3.872 3.872 0 0 0-5.455 0 3.837 3.837 0 0 0 0 5.435M151.875 47.203a3.872 3.872 0 0 0-5.455 0 3.837 3.837 0 0 0 0 5.434M150.507 56.71a3.872 3.872 0 0 0-5.455 0 3.838 3.838 0 0 0 0 5.434M155.074 39.507l15.161 15.105M149.605 44.942 164.78 60.06M146.42 52.65l12.906 12.844M145.039 62.144l17.759 17.692M162.798 79.836c7.178 7.15 18.826 7.15 26.003 0a18.24 18.24 0 0 0 4.99-9.153c.411-1.947.506-3.963.274-5.938"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m183.073 57.636-7.943-8.949a3.84 3.84 0 0 1 2.31-4.93c2.01-.722 3.295-.041 5.4 2.002 0 0 9.953 9.166 11.225 19M163.618 37.151l12.647 12.694"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  d: "M200.996 64.772a18.805 18.805 0 0 1-.287 6.061 18.61 18.61 0 0 1-5.086 9.343c-7.328 7.3-19.222 7.3-26.55 0L150.958 62.13a3.912 3.912 0 0 1 0-5.557 3.947 3.947 0 0 1 5.578 0l8.996 8.962-13.165-13.116a3.91 3.91 0 0 1 0-5.557 3.947 3.947 0 0 1 5.578 0l13.165 13.116-15.476-15.418a3.91 3.91 0 0 1 0-5.557 3.947 3.947 0 0 1 5.578 0l15.476 15.418-12.331-12.285a3.91 3.91 0 0 1 0-5.557 3.945 3.945 0 0 1 5.577 0l12.906 12.953"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M200.996 64.772a18.805 18.805 0 0 1-.287 6.061 18.61 18.61 0 0 1-5.086 9.343c-7.328 7.3-19.222 7.3-26.55 0L150.958 62.13a3.912 3.912 0 0 1 0-5.557 3.947 3.947 0 0 1 5.578 0l8.996 8.962-13.165-13.116a3.91 3.91 0 0 1 0-5.557 3.947 3.947 0 0 1 5.578 0l13.165 13.116-15.476-15.418a3.91 3.91 0 0 1 0-5.557 3.947 3.947 0 0 1 5.578 0l15.476 15.418-12.331-12.285a3.91 3.91 0 0 1 0-5.557 3.945 3.945 0 0 1 5.577 0l12.906 12.953"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  d: "m189.785 57.5-8.107-9.14a3.921 3.921 0 0 1 2.352-5.026c2.05-.735 3.363-.04 5.523 2.043 0 0 10.158 9.357 11.457 19.395"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m189.785 57.5-8.107-9.14a3.921 3.921 0 0 1 2.352-5.026c2.05-.735 3.363-.04 5.523 2.043 0 0 10.158 9.357 11.457 19.395M144.41 34.386l-7.068-7.069M148.484 31.43v-7.068M141.963 38.513h-7.096"
}))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
  id: "a"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M.5 0h220v125H.5z"
})), /*#__PURE__*/React.createElement(ClipPath, {
  id: "b"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M133.5 23h69v64h-69z"
}))));
export default Completed;
//# sourceMappingURL=Completed.js.map